module.exports = __webpack_public_path__ + "static/ymotongpoo-1384b92585a7990725cca91116ec7072.jpg";